import {z} from 'zod'

export const DAYS = ['MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT', 'SUN'] as const

export const DaysSchema = z.enum(DAYS)
export type Days = z.infer<typeof DaysSchema>

export const RecurrenceDaySchema = z.array(z.enum(DAYS))
export type RecurrenceDays = z.infer<typeof RecurrenceDaySchema>
